/* istanbul ignore file */
import React from 'react';
import { DropDownFilter } from 'framework/list';
import PerformanceMetricDropdown from 'domain/people/employee/shared/input/PerformanceMetricDropdown';

const PerformanceMetricFilter = (props: any) => {
  return (
    <DropDownFilter {...props}>
      <PerformanceMetricDropdown />
    </DropDownFilter>
  );
};

export default PerformanceMetricFilter;
